"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var antd_1 = require("antd");
Object.defineProperty(exports, "Progress", { enumerable: true, get: function () { return antd_1.Progress; } });
